import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navigation from './components/Navigation'
import HomePage from './pages/HomePage'
import HipsterDistricts from './pages/HipsterDistricts'
import WeirdTokyo from './pages/WeirdTokyo'
import Logistics from './pages/Logistics'
import Nightlife from './pages/Nightlife'
import ArticlePage from './pages/ArticlePage'
import ShimokitazawaPage from './pages/ShimokitazawaPage'
import HedgehogCafePage from './pages/HedgehogCafePage'
import NaritaTransferPage from './pages/NaritaTransferPage'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#0A0A0A]">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hipster-districts" element={<HipsterDistricts />} />
          <Route path="/weird-tokyo" element={<WeirdTokyo />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/nightlife" element={<Nightlife />} />
          <Route path="/article/:slug" element={<ArticlePage />} />
          <Route path="/shimokitazawa" element={<ShimokitazawaPage />} />
          <Route path="/hedgehog-cafe" element={<HedgehogCafePage />} />
          <Route path="/narita-transfer" element={<NaritaTransferPage />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
